module.exports = __webpack_public_path__ + "img/w-headphones.df7e2ef7.png";